module.exports = __webpack_public_path__ + "static/media/bg-intro-bottom-left.9aed9366.png";